import TrophiesCard from "../../Components/TrophiesCard/trophiesCard"
function Trophies() {
    return (
        <>
            <main>
                <TrophiesCard />
            </main>
        </>
    )
}

export default Trophies